<h2 mat-dialog-title>Deportistas</h2>
<mat-dialog-content>
  <div style="width: 100%" fxLayout="row" fxLayoutAlign="space-around center">
    <div>
      <span>Saldo:</span><span>{{ saldo | currency: "":"symbol":"1.0-0" }}</span>
    </div>
  
    <div>
      <span>Valor orden:</span
      ><span>{{ valOrdenTmp | currency: "":"symbol":"1.0-0" }}</span>
    </div>
  </div>

  <mat-toolbar>
    <mat-form-field appearance="outline" class="example-form-field">
      <mat-label>Nombre o Numero de documento</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="searchString"
        (keyup.enter)="onEnter()"
      />
      <button
        *ngIf="searchString"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="searchString = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field  appearance="outline" class="example-full-width" style="padding-left: 10px; font-size: smaller;">
      <mat-label>Disciplina</mat-label>
      <mat-select [(ngModel)]="disciplinaSelect" (selectionChange)="cambioDiscipinaBuscar()">
        <mat-option> Todas las disciplinas</mat-option>
        <mat-option *ngFor="let disciplinaTmp of lstDisciplinas" [value]="disciplinaTmp.id">
          {{disciplinaTmp.nombre}}
        </mat-option>
      </mat-select>

    </mat-form-field>

  </mat-toolbar>

  <mat-form-field appearance="outline" >
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z1 contenedorTabla" *ngIf="!isLoadingResults">
    <table mat-table [dataSource]="dataSource">
     
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element">{{ element.nombre }}
<br>
<small>
  {{ element.documento }}
</small>

        </td>
      </ng-container>
      
      <ng-container matColumnDef="disciplina">
        <th mat-header-cell *matHeaderCellDef>Disciplina</th>
        <td mat-cell *matCellDef="let element">{{ element.disciplina }}</td>
      </ng-container>

      <ng-container matColumnDef="plan">
        <th mat-header-cell *matHeaderCellDef>Plan</th>
        <td mat-cell *matCellDef="let element">{{ element.plan }}</td>
      </ng-container>

      <ng-container matColumnDef="fechaHasta">
        <th mat-header-cell *matHeaderCellDef>Hasta</th>
        <td mat-cell *matCellDef="let element">{{ element.fechaHasta | date: 'dd-MM-yyyy' }}</td>
      </ng-container>

      <ng-container matColumnDef="estadoDetalle">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let element"><!-- {{ element.estadoDetalle }} -->

          <mat-form-field  appearance="outline" class="example-full-width">
         <!--    <mat-select  (selectionChange)="cambioDiscipinaBuscar()" > -->
          <mat-select [value]="element.estadoDetalle+''" (selectionChange)="cambioEstadoDetalle(element,$event.value)">
              <mat-option value='0' disabled> Pendiente</mat-option>
              <mat-option value='1'> Aceptada</mat-option>
              <mat-option value='2'> Cancelada</mat-option>
            </mat-select>
      
          </mat-form-field>


        </td>
      </ng-container>

      <ng-container matColumnDef="botones">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">

          <button
           *ngIf="element.permiteRechazar"
          color="warm"
          mat-icon-button
          aria-label="Edit"
          (click)="rechazar(element)"
        >
          <mat-icon>cancel</mat-icon>
        </button> 


        </td>
      </ng-container>

<!--       <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef>Asignado</th>
        <td mat-cell *matCellDef="let element" style="text-align: center;">
          <mat-slide-toggle [checked]="element.estado" (change)="onToggle($event, element)"></mat-slide-toggle>
        </td>
      </ng-container> -->



      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 100]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <!--  <button type="submit" mat-button mat-flat-button color="primary" (click)='guardar()' [disabled]="registerForm.invalid">Guardar</button> -->
  <button mat-button mat-dialog-close="false">Cerrar</button>
</mat-dialog-actions>
